import { put, takeLatest } from 'redux-saga/effects';

import { logOut } from '../auth/actions';
import UserService from '../../../services/UserService';
import {
  getUserRequest,
  getUserSuccess,
  getUserFail,
  saveUserRequest,
  saveUserSuccess,
  saveUserFail,
  getCurrentUserRequest,
  getCurrentUserSuccess,
  getCurrentUserFail,
  saveCurrentUserRequest,
  saveCurrentUserSuccess,
  saveCurrentUserFail,
  getUserListRequest,
  getUserListSuccess,
  getUserListFail,
  clearUserState,
  initUserSuccess,
  initUserFail,
  initUserRequest,
  createUserRequest,
  createUserSuccess,
  createUserFail,
} from './actions';
import { apiCall } from '../../effects';
import { getErrorNotification } from '../../util';
import { notify } from '../notifications/actions';
import { replace } from "connected-react-router";

function* getTemplateUser() {
  try {
    const response = yield apiCall(UserService.template);
    yield put(initUserSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(initUserFail());
  }
}

function* createUser({ payload }: ReturnType<typeof createUserRequest>) {
  try {
    const user = yield apiCall(UserService.create, payload);
    yield put(createUserSuccess(user));
    yield put(replace(`/dashboard/admin/users/${user.id}/profile`));
  } catch (e) {
    yield put(initUserSuccess(payload));
    yield put(notify(getErrorNotification(e)));
    yield put(createUserFail());
  }
}

function* getCurrentUser() {
  try {
    const user = yield apiCall(UserService.getCurrent);
    yield put(getCurrentUserSuccess(user));
  } catch (e) {
    yield put(getCurrentUserFail());
  }
}

function* getUserList({ payload }: ReturnType<typeof getUserListRequest>) {
  try {
    const list = yield apiCall(UserService.list, payload);
    yield put(getUserListSuccess(list));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getUserListFail());
  }
}

function* getUser({ payload }: ReturnType<typeof getUserRequest>) {
  try {
    const user = yield apiCall(UserService.get, payload);
    yield put(getUserSuccess(user));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getUserFail());
  }
}

function* saveUser({ payload }: ReturnType<typeof saveUserRequest>) {
  try {
    const response = yield apiCall(UserService.save, payload.id, payload);
    yield put(saveUserSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(saveUserFail());
  }
}

function* saveCurrentUser({
  payload,
}: ReturnType<typeof saveCurrentUserRequest>) {
  try {
    const response = yield apiCall(UserService.save, payload.id, payload);
    yield put(saveCurrentUserSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(saveCurrentUserFail());
  }
}

function* logOutHandler() {
  yield put(clearUserState());
}

export default [
  takeLatest(initUserRequest.type, getTemplateUser),
  takeLatest(createUserRequest.type, createUser),
  takeLatest(getUserListRequest.type, getUserList),
  takeLatest(getCurrentUserRequest.type, getCurrentUser),
  takeLatest(getUserRequest.type, getUser),
  takeLatest(saveCurrentUserRequest.type, saveCurrentUser),
  takeLatest(saveUserRequest.type, saveUser),
  takeLatest(logOut.type, logOutHandler),
];
